import React from 'react';
import Button, { ButtonProps } from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import './Add.scss';

// TODO: If needed: export interface AddProps extends ButtonProps {}

export const Add = ( props: ButtonProps ) => {
  const { className, children } = props;
  const label = !children ? 'Add' : undefined;

  return (
    <Button
      data-testid="ops-add"
      variant="primary"
      title={ label }
      aria-label={ label }
      { ...props }
      className={ `ops-add${children ? ' ops-add--labeled' : ''}${className ? ` ${className}` : ''}` }
    >
      <FontAwesomeIcon icon={ faPlus } title="+" />
      { children ? <> { children }</> : null }
    </Button>
  );
};

Add.displayName = 'Add';
